import React, { Component } from 'react';
import compose from 'recompose/compose';
import { connect } from 'react-redux';
import { withStyles } from '@material-ui/core/styles';
import {
    resetMainListState,
    resetConsigneeListStateNew,
    changeCurrentPath,
    getKeiyakuKigyouListWD,
    getKeiyakuKigyou,
    clearKeiyakuKigyou,
    setKeiyakuKigyou,
    delKeiyakuKigyou,
    restoreKeiyakuKigyou, updateMasterFlag,
} from '../../../actions';

import Header from '../../../common/containers/header';
import Progress from '../../../common/containers/progress'
import SpNav from '../../../common/containers/sp_nav'
import Footer from '../../../common/containers/footer';

import ErrorDialog from '../../../common/components/dialog/error-dialog';
import ReloadModal from '../../../common/components/dialog/reload-dialog';
import LogoutModal from '../../../common/components/dialog/logout-dialog';

import MainButtons from '../../../common/components/main-buttons';

import InnerForms from './components/inner-form';

import FormGroup from '@material-ui/core/FormGroup';
import Select from '../../../common/components/input/creatable-select';
import {getValueHash, isObjectEquals} from "../../../common/utils/array";
import AlertDialog from "../../../common/components/dialog/alert-dialog";


const styles = theme => ({
    KeiyakuKigyouCD: {
        marginBottom:30
    },
    KeiyakuKigyouCDText:{
        color:'rgba(0, 0, 0, 0.54)',
        fontSize:'0.8125rem'
    }
});



class MasterKeiyakuKigyou extends Component {

    constructor(props) {
        super(props);
        this.state = {
            updateData:props.settings.data,
            KeiyakuKigyouCD : null,
            addKeiyakuKigyou:null,
            errors :{},
            isUpdate:false,
            dialogOpen:false,
            deleteDialogOpen:false
        }
    }
	/** override methods **/
    UNSAFE_componentWillMount() {
	    const {dispatch} = this.props;
        dispatch(getKeiyakuKigyouListWD());

        dispatch(resetMainListState());
        dispatch(resetConsigneeListStateNew());
	}


    /** override methods **/
	componentDidMount() {
		const { dispatch, history } = this.props;
		dispatch(changeCurrentPath({ currentPath: history.location.pathname }));
	}

    UNSAFE_componentWillReceiveProps(nextProps){
        if(nextProps.settings.isCompleteUpdate){
            this.doClear();
        }

        if(nextProps.settings.keiyakuKigyouIsChanged)
        {
            nextProps.dispatch(updateMasterFlag({keiyakuKigyouIsChanged:false}));
            this.setState({
                updateData:nextProps.settings.data,
            })
        }
    }

    /** event handlers **/
    handleClickSave = () =>{
        this.props.dispatch(setKeiyakuKigyou({
            KeiyakuKigyouCD:this.state.KeiyakuKigyouCD.value,
            data:this.state.updateData,
            SessionID:this.props.auth.SessionID
        }));
    };

    handleClickClear = () =>{
        if(this.state.isUpdate){
            this.setState({
                dialogOpen:true
            })
        }
        else{
            this.doClear();
        }
    };

    handleChangeOptions = (KeiyakuKigyouCD) =>{
        this.setState({KeiyakuKigyouCD})
        if(JSON.stringify(KeiyakuKigyouCD) !== JSON.stringify(this.state.addKeiyakuKigyou)){
            this.props.dispatch(getKeiyakuKigyou({KeiyakuKigyouCD:KeiyakuKigyouCD.value}));
        }
    };

    createOptions = (value) =>{
        const addKeiyakuKigyou = {
            "value" : value,
            "label" : value + " : (新規追加企業)"
        }

        this.setState({
            addKeiyakuKigyou,
            KeiyakuKigyouCD:addKeiyakuKigyou
        });
    }

    handleAfterChangeFunc = (updateData, errors) =>{
        const isUpdate = !isObjectEquals(updateData,this.props.settings.data);
        this.setState({
            updateData,
            errors,
            isUpdate
        });
    };

    doClear = () =>{
        this.props.dispatch(clearKeiyakuKigyou());
        this.setState({
            KeiyakuKigyouCD:null,
            addKeiyakuKigyou:null,
            updateData :getValueHash(this.props.settings.data),
            errors :{},
            isUpdate:false
        });
    }

    handleDoClear = () =>{
        this.setState({
            dialogOpen:false
        })
        this.doClear();
    }

    handleCancelClear = () =>{
        this.setState({
            dialogOpen:false
        })
    }

    handleClickDelete = () =>{
        this.setState({
            deleteDialogOpen:true
        })
    }

    handleClickRestore = () =>{
        this.props.dispatch(restoreKeiyakuKigyou({
            KeiyakuKigyouCD:this.state.KeiyakuKigyouCD.value,
            SessionID:this.props.auth.SessionID
        }));
    }

    handleDoDelete = () =>{
        this.setState({
            deleteDialogOpen:false
        })
        this.doDelete();
    }

    handleCancelDelete = () =>{
        this.setState({
            deleteDialogOpen:false
        })
    }

    doDelete = () =>{
        this.props.dispatch(delKeiyakuKigyou({
            KeiyakuKigyouCD:this.state.KeiyakuKigyouCD.value,
            SessionID:this.props.auth.SessionID
        }));
    }




    render() {
        const { settings, classes} = this.props;
        const {KeiyakuKigyouCD, addKeiyakuKigyou, errors, dialogOpen, deleteDialogOpen} = this.state;

        const selectedKeiyakuKigyou= Boolean(KeiyakuKigyouCD === null);
        const saveDisabled = Boolean(selectedKeiyakuKigyou || Object.keys(errors).length > 0);

        const isDelete = Boolean("DelFlag" in settings.data && settings.data["DelFlag"] === "1");
        let mainButtons;
        if(isDelete){
            mainButtons = [
                {type:'SAVE',func:this.handleClickSave,disabled:true},
                {type:'RELOAD',func:this.handleClickRestore,disabled: selectedKeiyakuKigyou,text:'復元'},
                {type:'CLEAR',func:this.handleClickClear,hasMargin:true}
            ];
        }
        else{
            mainButtons = [
                {type:'SAVE',func:this.handleClickSave,disabled:saveDisabled},
                {type:'DELETE',func:this.handleClickDelete,disabled: Boolean(addKeiyakuKigyou !== null || KeiyakuKigyouCD === null)},
                {type:'CLEAR',func:this.handleClickClear,hasMargin:true}

            ];
        }

        const allDisabled = selectedKeiyakuKigyou || isDelete;


        const KeiyakuKigyouList = (addKeiyakuKigyou === null) ? getValueHash(settings.keiyakukigyouData) : settings.keiyakukigyouData.concat([addKeiyakuKigyou]);
        return (
            <div id="main_container">
                {settings.isFetching &&
                <Progress/>
                }
                <SpNav history={this.props.history}/>
                <Header history={this.props.history}/>
                <article>
                    <section className="title_area">
                        <h2>企業マスタ</h2>
                    </section>
                    <section className="with_button">
                        <FormGroup className={classes.KeiyakuKigyouCD}>
                            <Select
                                inputLabel={"企業CD"}
                                fixValue={KeiyakuKigyouCD}
                                suggestions={KeiyakuKigyouList}
                                afterChangeFunction={this.handleChangeOptions}
                                afterCreateFunction={this.createOptions}
                                createTextPrefix={"企業"}
                                maxLength={13}
                            />
                            <div className={classes.KeiyakuKigyouCDText}>※新規で追加する際は新しいコードをここに入力してください</div>
                        </FormGroup>

                        <InnerForms
                            dataSource={settings.data}
                            allDisabled={allDisabled}
                            afterChangeFunc={this.handleAfterChangeFunc}
                            isAddConditions={Boolean(addKeiyakuKigyou !== null && KeiyakuKigyouCD !== null)}
                            isClear={Boolean(addKeiyakuKigyou === null && KeiyakuKigyouCD === null)}
                        />
                    </section>
                </article>
                <MainButtons buttons={mainButtons}/>
                <Footer/>
                <AlertDialog
                    open={dialogOpen}
                    title={"確認"}
                    text={<span>編集中のデータは破棄されます。<br/>よろしいですか？</span>}
                    okFunction={this.handleDoClear}
                    closeFunction={this.handleCancelClear}
                />
                <AlertDialog
                    open={deleteDialogOpen}
                    title={"確認"}
                    text={<span>この企業は削除されます。<br/>(編集中の内容は破棄されます)</span>}
                    okFunction={this.handleDoDelete}
                    closeFunction={this.handleCancelDelete}
                />
                <ErrorDialog
                    open={settings.isProcessError}
                />
				<ReloadModal />
                <LogoutModal />
            </div>
        );
    }
}

function mapStateToProps(state) {
  return {
	  navigation : state.navigation,
      auth: state.auth,
      settings : state.masterKeiyakuKigyouSettings,
  };
}
export default compose(
    withStyles(styles),
    connect(mapStateToProps)
)(MasterKeiyakuKigyou);



// WEBPACK FOOTER //
// ./src/routes/master/keiyaku-kigyou/index.js